// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ikhgwstphgvxruzrzzei.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlraGd3c3RwaGd2eHJ1enJ6emVpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg1MTQzNDMsImV4cCI6MjA2NDA5MDM0M30.ODR5EF21Xc3ldS1VmgoofdRJa4SNXJtg4s2RF9_oMxI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);